import { Flex } from '@chakra-ui/react';
import { MessageDividerWrapper } from './divider-wrapper';

export type MessageDividerLineProps = {
  children: React.ReactNode;
};

export const MessageDividerLine = memo(function MessageDividerLine({
  children,
}: MessageDividerLineProps) {
  return (
    <MessageDividerWrapper>
      <Flex
        align="center"
        gap="3"
        w="100%"
        fontSize="xs"
        color="fg"
        fontWeight="medium"
        _before={{
          flex: 'auto',
          content: '""',
          h: '1px',
          bg: 'linear-gradient(90deg, transparent, #adc6ff)',
        }}
        _after={{
          flex: 'auto',
          content: '""',
          h: '1px',
          bg: 'linear-gradient(270deg, transparent, #adc6ff)',
        }}
      >
        {children}
      </Flex>
    </MessageDividerWrapper>
  );
});
